// @flow
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../../common/JQueryView';

declare var $: any;

export default class ResolutionReportMinuteView extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    $('textarea').on('input', function() {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });

    this.initAdjustReportTextArea();
    this.initAdjustResolutionTextArea();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.addClass('form-control-active');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active').removeClass('is-invalid');
      removeInvalidFeedback(target);
    }
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    $(event.currentTarget)
      .prev('input[type=hidden]')
      .val('1');
    $(event.currentTarget)
      .closest('fieldset')
      .hide();
    event.preventDefault();
    this.updatePreview();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target)
      .parent()
      .before(
        $(event.target)
          .data('fields')
          .replace(regexp, time),
      );
    this.updatePreview();
  }

  @on({
    event: 'change',
    selector:
      '.officer_approval_director_meeting_resolutions_minute_comment textarea',
  })
  onChangeResolutionMinuteComment() {
    this.updatePreview();
  }

  @on({
    event: 'change',
    selector:
      '.officer_approval_director_meeting_minute_papers_content textarea',
  })
  onChangeMinutePaperContent() {
    this.updatePreview();
  }

  @on({
    event: 'change',
    selector:
      '.officer_approval_director_meeting_reports_minute_comment textarea',
  })
  onChangeReportMinuteComment() {
    this.updatePreview();
  }

  @on({
    event: 'change',
    selector:
      '.officer_approval_director_meeting_reports_interest_user_companies_user_company_id select',
  })
  onChangeReportInterestUserCompany() {
    this.updatePreview();
  }

  @on({
    event: 'change',
    selector:
      '.officer_approval_director_meeting_resolutions_interest_user_companies_user_company_id select',
  })
  onChangeResolutionInterestUserCompany() {
    this.updatePreview();
  }

  updatePreview() {
    if ($('#preview_button').length) {
      $('.simple_form').attr('data-remote', 'true');
      $('#preview_button').click();
      $('.simple_form').attr('data-remote', 'false');
    }
  }

  @on({
    event: 'mouseover',
    selector: '.hover-field a',
  })
  showHoverMessage(event: any) {
    const target = $(event.target);
    target
      .parent()
      .find('div')
      .removeClass('d-none')
      .addClass('d-block');
  }

  @on({
    event: 'mouseleave bluer',
    selector: '.hover-field',
  })
  hiddenHoverMessage() {
    $('.hover-message')
      .removeClass('d-block')
      .addClass('d-none');
  }

  initAdjustReportTextArea = (): void => {
    const targets = $('textarea');
    if (targets.length) {
      for (let i = 0; i < targets.length; i++) {
        targets[i].style.height = 'auto';
        targets[i].style.height = targets[i].scrollHeight + 'px';
      }
    }
  };

  initAdjustResolutionTextArea = (): void => {
    const targets = $('textarea');
    if (targets.length) {
      for (let i = 0; i < targets.length; i++) {
        targets[i].style.height = 'auto';
        targets[i].style.height = targets[i].scrollHeight + 'px';
      }
    }
  };
}
